import
  React
from 'react';

export default ({
  size = '30',
  ...props
}) => (
  <svg
    {...props}
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#333333"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.3749 6.27499H19.3499V5.62499C19.3499 3.91291 17.962 2.52499 16.2499 2.52499H13.7499C12.0378 2.52499 10.6499 3.91291 10.6499 5.62499V6.27499H5.6249C5.29353 6.27499 5.0249 6.54362 5.0249 6.87499C5.0249 7.20636 5.29353 7.47499 5.6249 7.47499H6.2749V25C6.2749 26.3669 7.383 27.475 8.7499 27.475H21.2499C22.6168 27.475 23.7249 26.3669 23.7249 25V7.47499H24.3749C24.7063 7.47499 24.9749 7.20636 24.9749 6.87499C24.9749 6.54362 24.7063 6.27499 24.3749 6.27499ZM22.5249 7.47499H7.4749V25C7.4749 25.7042 8.04574 26.275 8.7499 26.275H21.2499C21.9541 26.275 22.5249 25.7042 22.5249 25V7.47499ZM11.8499 5.62499V6.27499H18.1499V5.62499C18.1499 4.57565 17.2992 3.72499 16.2499 3.72499H13.7499C12.7006 3.72499 11.8499 4.57565 11.8499 5.62499ZM11.8499 22.5V11.25C11.8499 10.9186 11.5813 10.65 11.2499 10.65C10.9185 10.65 10.6499 10.9186 10.6499 11.25V22.5C10.6499 22.8314 10.9185 23.1 11.2499 23.1C11.5813 23.1 11.8499 22.8314 11.8499 22.5ZM15.5999 11.25V22.5C15.5999 22.8314 15.3313 23.1 14.9999 23.1C14.6685 23.1 14.3999 22.8314 14.3999 22.5V11.25C14.3999 10.9186 14.6685 10.65 14.9999 10.65C15.3313 10.65 15.5999 10.9186 15.5999 11.25ZM19.3499 11.25V22.5C19.3499 22.8314 19.0813 23.1 18.7499 23.1C18.4185 23.1 18.1499 22.8314 18.1499 22.5V11.25C18.1499 10.9186 18.4185 10.65 18.7499 10.65C19.0813 10.65 19.3499 10.9186 19.3499 11.25Z"
    />
    <mask
      x="5"
      y="2"
      id="maskTrash0"
      width="20"
      height="26"
      // maskType="alpha"
      maskUnits="userSpaceOnUse"
    >
      <path
        fill="white"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.3749 6.27499H19.3499V5.62499C19.3499 3.91291 17.962 2.52499 16.2499 2.52499H13.7499C12.0378 2.52499 10.6499 3.91291 10.6499 5.62499V6.27499H5.6249C5.29353 6.27499 5.0249 6.54362 5.0249 6.87499C5.0249 7.20636 5.29353 7.47499 5.6249 7.47499H6.2749V25C6.2749 26.3669 7.383 27.475 8.7499 27.475H21.2499C22.6168 27.475 23.7249 26.3669 23.7249 25V7.47499H24.3749C24.7063 7.47499 24.9749 7.20636 24.9749 6.87499C24.9749 6.54362 24.7063 6.27499 24.3749 6.27499ZM22.5249 7.47499H7.4749V25C7.4749 25.7042 8.04574 26.275 8.7499 26.275H21.2499C21.9541 26.275 22.5249 25.7042 22.5249 25V7.47499ZM11.8499 5.62499V6.27499H18.1499V5.62499C18.1499 4.57565 17.2992 3.72499 16.2499 3.72499H13.7499C12.7006 3.72499 11.8499 4.57565 11.8499 5.62499ZM11.8499 22.5V11.25C11.8499 10.9186 11.5813 10.65 11.2499 10.65C10.9185 10.65 10.6499 10.9186 10.6499 11.25V22.5C10.6499 22.8314 10.9185 23.1 11.2499 23.1C11.5813 23.1 11.8499 22.8314 11.8499 22.5ZM15.5999 11.25V22.5C15.5999 22.8314 15.3313 23.1 14.9999 23.1C14.6685 23.1 14.3999 22.8314 14.3999 22.5V11.25C14.3999 10.9186 14.6685 10.65 14.9999 10.65C15.3313 10.65 15.5999 10.9186 15.5999 11.25ZM19.3499 11.25V22.5C19.3499 22.8314 19.0813 23.1 18.7499 23.1C18.4185 23.1 18.1499 22.8314 18.1499 22.5V11.25C18.1499 10.9186 18.4185 10.65 18.7499 10.65C19.0813 10.65 19.3499 10.9186 19.3499 11.25Z"
      />
    </mask>
    <g mask="url(#maskTrash0)">
      <rect
        width="30"
        height="30"
        fill="#282828"
      />
    </g>
  </svg>
);